import { Product } from './product.model'


export class LoanProgram {
    public id: string;
    public name: string;
    public loanProgramAssignmentStrategies: LoanProgramAssignmentStrategy[];
    public products: Product[];
    public isActive: boolean;
    public loanChannelId: string;
    public isLoRelationship: boolean;
}

export class AddLoanProgram {
    public name: string;
    public loanProgramAssignmentStrategies: LoanProgramAssignmentStrategyAdd[];
    public loanChannelId: string;

}

export class LoanProgramLoRelationship {
    public loanProgramId: string;
    public isLoRelationship: boolean;
}

export class AssignmentStrategy {
    public id: string;
    public description: string;
    public tooltip: string;
}


export class LoanChannel {
    public id: string;
    public name: string;
}

export class LoanPurpose {
    public id: string;
    public name: string;
}

export class LoanProgramAssignmentStrategyAdd {
    public assignmentStrategyId: string;
    public personaId: string;
    constructor(asId: string, pId: string) {
        this.assignmentStrategyId = asId;
        this.personaId = pId;
    }
}
export class LoanProgramAssignmentStrategy {
    public id: string;
    public assignmentStrategyId: string;
    public assignmentStrategy: string;
    public personaId: string;
    public persona: string;
    public loanProgramId: string;
}

export class Region {
    public id: string;
    public name: string;
    public tooltip: string;
}





// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/loanprogram.model.ts